import { ChannelsEnum } from '@enums'

const channelEnumMap = {
  1: ChannelsEnum.ManualOrder,
  2: ChannelsEnum.Ebay,
  3: ChannelsEnum.Shopify,
  4: ChannelsEnum.Amazon,
  5: ChannelsEnum.BigCommerce,
  6: ChannelsEnum.Magento,
  7: ChannelsEnum.ShipStation,
  8: ChannelsEnum.Return,
  9: ChannelsEnum.WarehouseReceiving,
  10: ChannelsEnum.API,
  11: ChannelsEnum.WooCommerce,
  12: ChannelsEnum.BackerKit,
  13: ChannelsEnum.CrateJoy,
  14: ChannelsEnum.StitchLabs,
  15: ChannelsEnum.Exchange,
  16: ChannelsEnum.Zapier,
  17: ChannelsEnum.Walmart,
  18: ChannelsEnum.Excel,
  19: ChannelsEnum.TicTail,
  20: ChannelsEnum.PrepaidStandardCarrier,
  21: ChannelsEnum.PrepaidFreight,
  22: ChannelsEnum.ExternalInventoryTransfer,
  23: ChannelsEnum.InternalInventoryTransfer,
  24: ChannelsEnum.SquareSpace,
  25: ChannelsEnum.ManualB2B,
  26: ChannelsEnum.SpsCommerce,
  27: ChannelsEnum.Kitting,
  28: ChannelsEnum.TikTok,
  29: ChannelsEnum.Transportation
}

const getChannelForAPI = (value) => {
  return Object.keys(channelEnumMap).find(key => channelEnumMap[key] === value)
}

const mapChannelFromAPI = ({id, storeOrderId}) => ({
  id,
  name: channelEnumMap[id],
  storeOrderId
})

const mapChannelForUpsert = (channel) => {
  return {
    id: getChannelForAPI(channel)
  }
}

export default {
  mapChannelFromAPI,
  mapChannelForUpsert
}
